// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message[data-v-ac3a7128]{padding:12px 12px 12px 12px;text-align:center}.notice[data-v-ac3a7128]{background-color:#f2f2f2}", ""]);
// Exports
module.exports = exports;
